// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__1F7gD","input":"Form_input__1jqBF","btn":"Form_btn__2_HPa","btns":"Form_btns__11REx","button":"Form_button__3foNr"};